/* eslint-disable */
const mutations = {
  setRegistrationMethods(state, { registrationMethods }) {
    state.data = registrationMethods;
  },
};

export default mutations;
